import axios from "axios";
import { Config } from "../config/Config";

/**
 * バックエンドAPI連携サービス
 * @param apiToken トークン
 */
export const MygruBackendService = (apiToken: string) => {
    /**
     * スタンプカード初期化APIを実行
     * @param user ユーザーID
     * @param campaignId キャンペーンID
     */
    const initStampCard = async (user: string, campaignId: string) => {
        await axios.post(`${Config.backendBaseUrl}/api/stamp-cards/init`,
            { user, campaignId },
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiToken}`
                }
            });
    };

    /**
     * スタンプカードのリコメンドAPIを実行
     * @param user ユーザーID
     * @param campaignId キャンペーンID
     * @param categories リコメンドを取得するカテゴリ
     */
    const recommendStampCard = async (user: string, campaignId: string, categories: string[]) => {
        await axios.post(`${Config.backendBaseUrl}/api/stamp-cards/recommend-stamps`,
            { user, campaignId, categories },
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiToken}`
                }
            });
    };

    /**
     * スタンプカード更新APIを実行
     * @param user ユーザーID
     * @param campaignId キャンペーンID
     */
    const updateStampCard = async (user: string, campaignId: string) => {
        await axios.post(`${Config.backendBaseUrl}/api/stamp-cards/update`,
            { user, campaignId },
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiToken}`
                }
            });
    }

    /**
     * スタンプカードにスタンプを設定するAPIを実行
     * @param campaignId キャンペーンID
     * @param stampCardId スタンプカードID
     * @param stampIds スタンプID
     * @param isCcmabUpdate CCMABモデルを更新するか
     */
    const setStamps = async (campaignId: string, stampCardId: string, stampIds: any[], isCcmabUpdate?: boolean) => {
        await axios.post(`${Config.backendBaseUrl}/api/stamp-cards/set-stamps`,
            { "campaignId": campaignId, stampCardId, stampIds, isCcmabUpdate },
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiToken}`
                }
            });
    }


    return { initStampCard, recommendStampCard, updateStampCard, setStamps }
};
